import { EventHandler } from "../../util/event/EventHandler";
import { ResultCode } from "../common/controller/net/constant/Constants";
import { SetSettingsRequest } from "../common/controller/net/request/SetSettingsRequest";
import { AbstractHandler } from "../core/handler/AbstractHandler";
import { SetSettingsResult } from "./SetSettingsResult";
/**
 * SetSettingsHandler.ts
 */
export class SetSettingsHandler extends AbstractHandler {
    constructor(parameters, action, scope) {
        super();
        this.parameters = parameters;
        this.eventHandler = new EventHandler(action, scope);
    }
    destroy() {
        super.destroy();
        this.parameters = null;
        this.eventHandler = null;
    }
    run() {
        super.run();
        this.send();
    }
    send() {
        let request = new SetSettingsRequest(this.parameters);
        request.onSuccess(this.handleSuccess, this);
        request.onFailure(this.handleFailed, this);
        request.send();
    }
    handleSuccess(data) {
        this.handleAction(new SetSettingsResult(ResultCode.SUCCESS, data));
    }
    handleFailed(data) {
        this.handleAction(new SetSettingsResult(data.getResponseCode()));
    }
    handleAction(result) {
        this.eventHandler.call(result);
        this.destroy();
    }
}
//# sourceMappingURL=SetSettingsHandler.js.map